<template lang="pug">
v-fade-transition
    v-container(fluid :class="expand && isMobile ? 'container--expand' : ''").suus__search-box
        v-row(no-gutters).suus__search-box__row
            v-col(cols="2" sm="1" v-if="isMobile").suus__search-box__button
                v-btn(@click="handleExpand" icon x-small v-if="expand")
                    v-icon(small color="textColor") {{ collapseIcon }}
                v-btn(@click="handleExpand" icon v-else)
                    v-icon(color="primary") {{ searchIcon }}
            v-col(
                cols="10"
                sm="11"
                lg="12"
                v-model="focused"
                :class="{ focused: focused }"
            )
                v-expand-x-transition
                    v-row(no-gutters v-show="expand" width="300" height="40")
                        v-col(cols="10")
                            v-autocomplete(
                                v-model="select"
                                :loading="loading"
                                :items="searchData"
                                :search-input.sync="search"
                                :append-icon="null"
                                :hide-no-data="hideNoData"
                                :close-on-click="true"
                                :menu-props="{closeOnClick: true}"
                                dense
                                placeholder="Suche Mitglied"
                                item-text="name"
                                item-value="name"
                                filled
                                rounded
                                no-filter
                                @focus="focused = true"
                                @blur="focused = false"
                            ).suus__search-box__input
                                template(v-slot:prepend-inner)
                                    v-icon(color="primary") {{ searchIcon }}
                                template(v-slot v-on:keyup.enter="handleSelect(data.item)") {{ data.item.name }}
                                template(v-slot:item="data")
                                    v-list-item(@click="handleSelect(data.item)")
                                        v-list-item-avatar
                                            v-img(v-if="data.item.avatar" :src="data.item.avatar")
                                                 template(v-slot:placeholder)
                                                    v-row(
                                                    class="fill-height ma-0"
                                                    align="center"
                                                    justify="center"
                                                    )
                                                        v-icon {{userIcon}}
                                        v-list-item-content.suus__search-box__input__content
                                            v-list-item-title(v-html="data.item.name")
                                            v-list-item-subtitle(v-html="data.item.description")
                                template(v-slot:no-data)
                                    p(v-if="loading").body-2.font-weight-medium.text-center Auf der Suche ...
                                    p(v-else).body-2.font-weight-medium.text-center Nichts gefunden
                        v-col(cols="2")
                            v-menu(
                                v-model="showModal"
                                :disabled="disabled"
                                :close-on-click="true"
                                transition="slide-y-transition"
                                bottom
                                :max-width="300"
                                :nudge-left="250"
                                :nudge-bottom="40"
                            )
                                template(v-slot:activator="{ on, attrs }")
                                    v-input(
                                        v-model="disabled"
                                        v-bind="attrs"
                                        v-on="on"
                                        filled
                                        rounded
                                        readonly
                                        height="40"
                                        @click="handleBadgeClick"
                                        :class="{ disabled: disabled }"
                                        ).suus__search-box__filter
                                        template(v-slot)
                                            v-badge(
                                                bordered
                                                dot
                                                overlap
                                                :value="showBadge"
                                                :color="disabled? 'primary lighten-4' : 'primary'"
                                            ).suus__badge--primary
                                                v-icon(:color="disabled? 'lightGrey' : 'textColor'") {{personSearchIcon}}
                                v-card.d-flex.flex-column.included
                                    v-btn(icon @click="showModal = false").align-self-end
                                        v-icon(color="textColor") {{closeIcon}}
                                    .pa-4
                                        ConfettiSearch
                                        h2(color="textColor").suus__header Hier kannst Du nach Mitgliedern suchen
                                        p(color="textColor").suus__text Tippe den Namen in das Suchfeld und Du bekommst passende Vorschläge.
                                        p(color="textColor").suus__text.mb-8 Weitere Suchmöglichkeiten folgen.
                                        Button(btnLabel="Verstanden" @click="showModal = false")
</template>
<script lang="ts">
import Vue from "vue"
import ConfettiSearch from "../components/graphics/ConfettiSearch.vue"
import Button from "../components/UI/Button.vue"
import { mdiMagnify } from "@mdi/js"
import { mdiClose } from "@mdi/js"
import { mdiAccountSearchOutline } from "@mdi/js"
import { mdiChevronDoubleRight } from "@mdi/js"
import { mdiAccountCircleOutline } from "@mdi/js"
import { mdiHelpCircleOutline } from "@mdi/js"
import { membersApi } from "store/api"
import _ from "lodash"

export default Vue.extend({
  name: "SearchPerson",
  components: { ConfettiSearch, Button },
  data() {
    return {
      hideNoData: true,
      search: "",
      select: null,
      error: false,
      loading: false,
      focused: false,
      disabled: false,
      showModal: false,
      showBadge: true,
      isMobile: this.$vuetify.breakpoint.mobile,
      expand: !this.$vuetify.breakpoint.mobile,
      searchIcon: mdiMagnify,
      closeIcon: mdiClose,
      collapseIcon: mdiChevronDoubleRight,
      personSearchIcon: mdiAccountSearchOutline,
      helpIcon: mdiHelpCircleOutline,
      userIcon: mdiAccountCircleOutline,
      searchData: [],
      debouncedGetResults: () => {},
    }
  },
  created: function () {
    this.debouncedGetResults = _.debounce(this.getResults, 500)
  },
  mounted: function () {
    let searchBox = document.getElementById("search")
    if (!searchBox) return

    searchBox.onclick = function () {
      let isExpanded, scrollAmount, slideTimer, slide_el
      isExpanded = document.getElementsByClassName(
        "suus__search-box container--expand"
      ).length
      slide_el = document.getElementById("suus__sub-nav")
      scrollAmount = 0
      if (isExpanded) {
        slideTimer = setInterval(function () {
          slide_el.scrollLeft += 25
          scrollAmount += 25
          if (scrollAmount >= 320) {
            window.clearInterval(slideTimer)
          }
        }, 25)
      }
    }

    return
  },
  methods: {
    toUrl(url) {
      window.location = url
    },
    handleExpand() {
      if (this.isMobile) {
        this.expand && this.resetData()
        this.expand = !this.expand
      }
    },
    handleSelect(item): void {
      this.toUrl(item.link)
      this.select = item.name
    },
    handleBadgeClick(): void {
      if (this.disabled) {
        return
      }
      this.showBadge = false
      this.disabled = false
    },
    resetData(): void {
      this.searchData = []
      this.hideNoData = true
      this.search = ""
    },
    disableModal(): void {
      this.showModal = false
      this.disabled = true
    },
    activateModal(): void {
      this.showBadge && this.disabled
        ? (this.disabled = false)
        : (this.disabled = true)
    },
    sanitizeResults(data) {
      return data.map((record) => {
        const { alive, avatar_url = "", list_name, id } = record
        let strippedListName = list_name.replace(/(<([^>]+)>)/gi, "")
        const description = alive
          ? this.recordDescriptionAlive(record)
          : this.recordDescriptionDead(record)
        const link = `${window.location.origin}/member/${id}`
        return {
          name: strippedListName,
          description: description,
          avatar: avatar_url,
          link: link,
        }
      })
    },
    recordDescriptionAlive(record) {
      const { postal_code = "", region = "", age = "" } = record
      const age_description = `${age ? `${age} Jahre` : ""}`
      const comma = age && (postal_code || region) ? ", " : ""
      const region_description = `${
        postal_code || region
          ? `in ${postal_code ? postal_code + " " : ""}${region}`
          : ""
      }`
      return age_description + comma + region_description
    },
    recordDescriptionDead(record) {
      const { date_of_death } = record
      return `✝ verstorben ${date_of_death || ""}`
    },
    getResults() {
      this.searchData = []
      this.error = false
      this.hideNoData = true
      if (this.search) {
        this.loading = true
        this.hideNoData = false
        membersApi
          .fuzzySearch(this.search, undefined, undefined, undefined, true)
          .then((res) => {
            const { results: membersFound } = res.data
            if (membersFound) {
              this.searchData = this.sanitizeResults(membersFound)
            }
          })
          .catch((error) => {
            console.log(error)
            this.error = true
          })
          .finally(() => (this.loading = false))
      }
    },
  },
  watch: {
    search(val: string) {
      //console.log(val)
      if (val && val.length > 0) {
        this.disableModal()
      }
      if (!val || val.length === 0) {
        this.activateModal()
        this.hideNoData = false
      }
      if (val && val !== this.select) {
        this.debouncedGetResults()
      }
    },
  },
})
</script>

<style lang="sass">
@use "sass:color"
$font: system-ui
$primary-color: rgba(50, 131, 247, 1)
$text-color: rgba(66, 66, 66, 1)
$lightGrey-color: rgba(229, 229, 229, 1)
%font-stack
  font-family: $font
  color: $text-color
.suus__text
    @extend %font-stack
.suus__header
    @extend %font-stack
.suus__search-box
    max-width: 450px
    padding: 4px 10px
    margin: 0
    &.container--expand
        min-width: 320px !important
    &__row
        flex-wrap: nowrap
        align-items: center
    &__button
        margin: 2px 0
    &__input
        .v-input__slot
            padding: 0 10px !important
            border-radius: 28px 0 0 28px !important
            border: 1px solid $lightGrey-color
            border-right: 0px
            background: none !important
            @extend %font-stack
            margin-bottom: 0 !important
            .focused &
                border-color: color.adjust($primary-color, $alpha: -0.5)
        .v-text-field__details
            display: none
            height: 0px
        &__content
            .v-list-item__title
                @extend %font-stack
                font-size: 1em !important
            .v-list-item__subtitle
                @extend %font-stack

    &__filter
        .v-input__slot
            border-radius: 0px 19px 19px 0px !important
            border: 1px solid $lightGrey-color
            display: flex
            justify-content: center
            margin-bottom: 0 !important
            @extend %font-stack
            .focused &
                border-color: color.adjust($primary-color, $alpha: -0.5)
        .v-messages
            display: none
            height: 0px
</style>
